import { FilterHeaderProps, FilterHeaderRef } from "./types"
import { useFilter } from "../../../../../../hooks/filter"
import { FilterHeaderTemplate } from "./filterHeaderTemplate"
import { Ref, forwardRef, useImperativeHandle, useState } from "react"
import { ObjectGeneric } from "../../../../../../utils/types/generals"
const FilterHeader = forwardRef((props: FilterHeaderProps, ref:Ref<FilterHeaderRef>) => {
  const [modal, setModal] = useState<{
    open: boolean
  }>({
    open: false,
  })
    const [dafaultValue, setDefaultValue] = useState<ObjectGeneric>(props.defaultValues)
    const [count, setCount] = useState<number | null>(Object.values(props.defaultValues ?? {})?.length)
    const filter = useFilter({ formatFilter: {}, defaultValues: props.defaultValues, externalValidation: props.externalValidation })

    useImperativeHandle(ref, () => ({
      getValues: () => dafaultValue
    }))
    const refresh = () => {
      props.refresh({dafaultValue: filter.filterData})
    }

    const openModal = () => {
      filter.handleDefaultValues({defaultValue: dafaultValue})
        setModal(prev => ({...prev, open: true}))
    }

    const cleanFilter = () => {
      filter.cleanFilter()
      props.filterData({dafaultValue: {}})
      setDefaultValue({})
      setCount(props?.countDefault ?? null)
      props.cleanFilter()
    }

    const closeFiltersModal = () => {
      setModal(prev => ({...prev, open: false}))
      filter.cleanFilter()
    }

    const filterButton = () => {
      setDefaultValue(filter.filterData)
      setCount(((filter?.counter ?? 0) + (props?.countDefault ?? 0)) || props?.countDefault || null)
      props.filterData({dafaultValue: filter.filterData})
      closeFiltersModal()
    }

    return <FilterHeaderTemplate hiddenRefresh={props.hiddenRefresh} title={props.title} input={props.input} filterButton={filterButton} modal={modal} cleanFilter={cleanFilter} filter={{...filter, counter: count}} closeFiltersModal={closeFiltersModal}  openModal={openModal} refresh={refresh}/>
})

export { FilterHeader }
